import Vue from 'vue'
import VueRouter from 'vue-router'
import CostRefetch from '../views/CostRefetch.vue'
import Home from '../views/Home.vue'
import HomeV2 from '../views/HomeV2.vue'
import InfluencerCosts from '../views/InfluencerCosts.vue'
import InfluencerMonthlyCosts from '../views/InfluencerMonthlyCosts.vue'
import UploadCoupon from '../views/UploadCoupon.vue'
import Signin from '../views/Signin.vue'
import AuthLoginCallback from '../components/AuthLoginCallback.vue'
import tokenManagerService from '../services/tokenManager'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/v2',
    name: 'HomeV2',
    component: HomeV2
  },
  {
    path: '/signin',
    name: 'Signin',
    component: Signin,
    meta: { requiresAuth: false }
  },
  {
    path: '/login/callback',
    name: 'LoginCallback',
    component: AuthLoginCallback,
    meta: { requiresAuth: false }
  },
  {
    path: '/refetch',
    name: 'CostRefetch',
    component: CostRefetch
  },
  {
    path: '/influencer-costs',
    name: 'InfluencerCosts',
    component: InfluencerCosts
  },
  {
    path: '/influencer-monthly-costs',
    name: 'InfluencerMonthlyCosts',
    component: InfluencerMonthlyCosts
  },
  {
    path: '/upload-coupon',
    name: 'UploadCoupon',
    component: UploadCoupon
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// Navigation guard for authentication
router.beforeEach(async (to, from, next) => {
  // Allow public routes
  if (to.meta.requiresAuth === false) {
    return next();
  }

  // Also allow these paths explicitly
  if (['/signin', '/login/callback'].includes(to.path)) {
    return next();
  }

  // Check authentication
  try {
    const token = await tokenManagerService.getValidToken();
    
    if (!token) {
      console.log("🔒 Access denied. Redirecting to signin.");
      if (to.fullPath !== '/' && to.fullPath !== '/signin') {
        sessionStorage.setItem('okta_redirect_path', to.fullPath);
      }
      return next('/signin');
    }

    // Ensure user info is loaded
    if (!store.getters.user) {
      await store.dispatch('setUser');
    }

    next();
  } catch (error) {
    console.error("❌ Router auth check error:", error);
    if (to.fullPath !== '/' && to.fullPath !== '/signin') {
      sessionStorage.setItem('okta_redirect_path', to.fullPath);
    }
    return next('/signin');
  }
});

export default router
